function mtCartGiftSync() {
  var MAIN_PRODUCT_IDS = [8887528226868, 8888113070132, 8888389107764, 8889979830324, 8889988022324, 8889988481076];
  var GIFT1_PRODUCT_ID = 8888389107764;
  var GIFT2_PRODUCT_ID = 8888113070132;

  function run() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var mainQty = 0;
        cart.items.forEach(function (item) {
          var isGift = item.properties && item.properties._mt_regalo;
          if (!isGift && MAIN_PRODUCT_IDS.indexOf(item.product_id) !== -1) mainQty += item.quantity;
        });
        var firings = Math.min(Math.floor(mainQty / 2), 2);
        var desiredGift1 = firings >= 1 ? 1 : 0;
        var desiredGift2 = firings >= 2 ? 1 : 0;

        var gift1Line = cart.items.find(function (i) {
          return i.product_id === GIFT1_PRODUCT_ID && i.properties && i.properties._mt_regalo === 'gift1';
        });
        var gift2Line = cart.items.find(function (i) {
          return i.product_id === GIFT2_PRODUCT_ID && i.properties && i.properties._mt_regalo === 'gift2';
        });

        var updates = {};
        var needsUpdate = false;
        if (gift1Line && desiredGift1 < gift1Line.quantity) {
          updates[gift1Line.key] = desiredGift1;
          needsUpdate = true;
        }
        if (gift2Line && desiredGift2 < gift2Line.quantity) {
          updates[gift2Line.key] = desiredGift2;
          needsUpdate = true;
        }
        if (!needsUpdate) return;

        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates }),
        }).then(function () {
          window.location.reload();
        });
      });
  }

  run();
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, run);
  }
  document.addEventListener('cart:refresh', run);
}

document.addEventListener('DOMContentLoaded', mtCartGiftSync);
